import { combineReducers } from 'redux';
import { Reducer } from './Reducer';

const Reducers = combineReducers({
    reducer : Reducer
})

export default Reducers